import { message, notification } from 'antd';
import {get} from 'lodash';
import axios from 'axios';
import Config from '../../configs';

const msgKey = 'login';

export async function login({loginBody}) {
    try { 
        const response = await axios.post(`${Config.baseUrl}/auth/login`, loginBody, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            }
        })
        message.open({
            key: msgKey,
            type: 'success',
            content: 'Authorized',
            duration: 3
        });
        return response;
    } catch (error) {
        message.destroy()
        const errorMessage = get(error, 'response.data.message') 
        || get(error, 'response.statusText')
        || error.toString();
        notification.error({
            key: msgKey,
            message: errorMessage
        })
        throw error;
    }
}
  